import {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Tooltip,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  ExitToApp as ExitToAppIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import Authentication from 'Authentication';

export default function AppAppBar(props) {
  const {classes, user, drawerOpen, onOpenDrawer} = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const handleTouchTapPopover = () => setPopoverOpen(true);
  const handleClosePopover = () => setPopoverOpen(false);

  return (
    <AppBar
      position="absolute"
      className={` printDisplayNone ${classNames(
        classes.appBar,
        drawerOpen && classes.appBarShift,
      )}`}
    >
      <Toolbar disableGutters={!drawerOpen}>
        <Tooltip title="Expand Menu">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={onOpenDrawer}
            className={classNames(
              classes.menuButton,
              drawerOpen && classes.hide,
            )}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
        <Typography variant="h6" color="inherit" noWrap style={{flex: 1}}>
          {process.env.REACT_APP_APP_NAME}
        </Typography>
        <Tooltip title="User Settings">
          <Button
            variant="contained"
            color="primary"
            buttonRef={(node) => {
              setAnchorEl(node);
            }}
            onClick={handleTouchTapPopover}
            endIcon={<ExpandMoreIcon />}
          >
            {`${user.firstName} ${user.lastName}`}
          </Button>
        </Tooltip>
        <Popover
          open={popoverOpen}
          anchorEl={anchorEl}
          anchorReference="anchorEl"
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          onClose={handleClosePopover}
        >
          <MenuList>
            <Tooltip title="Logout">
              <MenuItem onClick={Authentication.logout}>
                <ListItemIcon>
                  <ExitToAppIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </MenuItem>
            </Tooltip>
          </MenuList>
        </Popover>
      </Toolbar>
    </AppBar>
  );
}

AppAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  onOpenDrawer: PropTypes.func.isRequired,
};
